import {consoleFancyClient, extractData} from '@frontrow/console/src/open-api/clients'
import {type RosteringFilesT} from '@frontrow/console/src/entities/models/roster-sync'

import {type PatchStudentSisIdT} from '@frontrow/console/src/components/pages/import-sis-ids'

export function fetchMatchResults(
  fetchDataParams: RosteringFilesT,
  districtId: number
): Promise<unknown> {
  const formData = new FormData()
  const {teachersCsv, studentsCsv, coursesCsv, enrollmentsCsv} = fetchDataParams

  formData.append('teachers.csv', teachersCsv, teachersCsv.name)
  formData.append('students.csv', studentsCsv, studentsCsv.name)
  formData.append('courses.csv', coursesCsv, coursesCsv.name)
  formData.append('enrollments.csv', enrollmentsCsv, enrollmentsCsv.name)

  // The spec types the multipart body as `unknown`; openapi-fetch sends a
  // FormData as is and lets the browser set the multipart boundary.
  return consoleFancyClient
    .POST('/2/districts/{DistrictP-DistrictId}/rosters/sis-id-sync', {
      params: {path: {'DistrictP-DistrictId': districtId}},
      body: formData
    })
    .then(extractData)
}

export function patchMatchResults(patchSisIdsPayload: Array<PatchStudentSisIdT>): Promise<unknown> {
  return consoleFancyClient.PATCH('/2/students', {body: patchSisIdsPayload})
}
